export const defaultQueryParams = {
  // Docs: https://tanstack.com/query/v4/docs/framework/react/reference/useQuery
  retry: 0,
  refetchOnWindowFocus: false,
  retryOnMount: false,
  refetchOnMount: false,
  staleTime: 300000, // 5 mins in milliseconds
};

export enum QueryKey {
  Conditions = "Conditions",
  Items = "Items",
  Templates = "Templates",
  TemplateOptions = "TemplateOptions",
  ScaleOptions = "ScaleOptions",
  Processes = "Processes",
  WorkOrders = "WorkOrders"
}
